var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"costs"},[_c('h2',{staticClass:"costs__title"},[_vm._v(" "+_vm._s(_vm.$t('WIZARD.COSTS.TITLE'))+" ")]),_c('div',{staticClass:"costs__container"},_vm._l((_vm.items),function(item,index){return _c('costs-item',{key:index,attrs:{"image":item.image,"title":item.title,"content":item.content}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }